import intersectionWith from "lodash-es/intersectionWith";
import differenceWith from "lodash-es/differenceWith";

export const bindAllClassMethods = context => {
  if (
    context &&
    context.constructor &&
    context.constructor.prototype &&
    context.constructor.prototype instanceof Object
  ) {
    Object.getOwnPropertyNames(context.constructor.prototype).map(f => {
      if (typeof context[f] === "function") {
        context[f] = context[f].bind(context);
      }
    });
  }
};

// a = code requires this scope
// b = user has this scope
const compareScope = (a, b) => {
  const aSplit = a.split(":"),
    aScope = aSplit[0],
    aPerm = aSplit[1],
    bSplit = b.split(":"),
    bScope = bSplit[0],
    bPerm = bSplit[1];

  let aScopePath = aScope.split("/"),
    bScopePath = bScope.split("/");

  // If the required scope is a sub-scope, check for parent scopes that encompass the sub scope
  if (aScopePath.length > 1 && bScope === "registry") {
    let match = true;
    for (let i = 0; i < bScopePath.length; i++) {
      if (aScopePath[i] !== bScopePath[i]) {
        match = false;
      }
    }

    if (match) {
      if (!bPerm || aPerm === bPerm) {
        return true;
      }
    }
  }

  // If no modifier and not pathed, compare directly
  if (!aPerm && !bPerm) {
    return a === b;
  }

  // If there is a modifier, check if userScopes has the root
  // or if userScopes has the exact match
  if (aPerm) {
    return aScope === b || a === b;
  }

  return false;
};

export const diffScopes = (requiredScopes = [], userScopes = []) => {
  const int = intersectionWith(requiredScopes, userScopes, compareScope);

  if (int.length !== requiredScopes.length) {
    return differenceWith(requiredScopes, int, (a, b) => {
      return compareScope(a, b);
    });
  }

  return null;
};

export const lightOrDark = color => {
  if (!color) {
    return "light";
  }

  // Variables for red, green, blue values
  let r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  } else {
    return "dark";
  }
};
